import '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/polyfills/request-submit.js';
import { sanitize } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/sanitize.js';
/**
 * Returns an object of key/value pairs of form element `names` and `values`.
 *
 * @param formData the formData object constructor
 * @returns a new object containing all submitted names and values
 */
export const getFormDataEntries = (formData) => {
    const values = {};
    for (const [key, value] of formData.entries()) {
        values[key] = value;
    }
    return values;
};
/**
 * Manually dispatches a `formdata` event to support other browsers.
 *
 * TODO - remove fallback when Android Firefox supported
 * https://caniuse.com/mdn-api_htmlformelement_formdata_event
 *
 * @param target The form element
 *
 * @returns the FormData object
 */
export const dispatchFormDataEvent = (target) => {
    const formData = new FormData(target);
    const formDataEvent = new CustomEvent('formdata', {
        bubbles: true,
        cancelable: false,
        composed: false,
    });
    formDataEvent.formData = formData;
    target.dispatchEvent(formDataEvent);
    return formData;
};
/**
 * Generic utility to submit the form.
 *
 * @param form The form element
 */
export const submitForm = async (form) => {
    var _a;
    // ensure we have access to inner form element
    await (form === null || form === void 0 ? void 0 : form.shadowRoot);
    // sanitize values before form data capture
    form.querySelectorAll('*').forEach((element) => {
        if (element.tagName.includes('-INPUT') || element.tagName.includes('-TEXTAREA') || element.tagName.includes('-DATE-PICKER')) {
            element.setAttribute('value', sanitize(element.value));
        }
    });
    (_a = form._form) === null || _a === void 0 ? void 0 : _a.requestSubmit();
};
//# sourceMappingURL=formdata.js.map